export enum HydrateSource {
  CANCELED_APPLICATION = 'CANCELED_APPLICATION',
  MAIL_CODE = 'MAIL_CODE',
  PREVIEW = 'PREVIEW',
  VEHICLE_SELECTION = 'VEHICLE_SELECTION',
}
